import { ApiVolumeByApplicationGroupingType } from './getDataSecurityApiVolumeByApplication';
import { createPostEndpoint } from '@sonar-software/sonar-http';
import { DateRangeQueryParams } from '@sonar-software/sonar-ts-types';

export type PostApiVolumeTableExportRequest = DateRangeQueryParams & {
	calendarGroupingType: ApiVolumeByApplicationGroupingType;
};

export type PostApiVolumeTableExportResponse = { id: number };

export const postApiVolumeTableExportStart = createPostEndpoint<
	PostApiVolumeTableExportRequest,
	PostApiVolumeTableExportResponse
>(
	'/api/v3/core/exports/api-volume-table/export/start'
);
